import React from "react";
import { Form, FormikProps, Formik } from "formik";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { changePasswordSchema } from "../../features/auth/validation";

import { FormikTextField } from "../Layout/FormikTextField";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { changePassword, selectAuth } from "../../features/auth/authSlice";

import Toast from "../Layout/Toast";
import { UpdatePassword } from "../../features/auth/types/authType";
import { useTranslation } from "react-i18next";

const ChangePassword = () => {
  const theme = useTheme();
  const { t: ta } = useTranslation("auth");
  const { error } = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();

  return (
    <Formik
      key="2"
      initialValues={{
        userId: "",
        oldPassword: "",
        password: "",
        confirmPassword: "",
      }}
      validationSchema={changePasswordSchema}
      onSubmit={(values, actions) => {
        actions.setSubmitting(false);

        dispatch(changePassword(values));
      }}
    >
      {(props: FormikProps<UpdatePassword>) => (
        <Form>
          <Card>
            <CardHeader
              subheader={ta("changePassword")}
              title={ta("password")}
            />
            <Divider />
            <CardContent>
              <FormikTextField
                autoComplete="off"
                formikKey="oldPassword"
                label={ta("oldPassword")}
                type="password"
              />
              <FormikTextField
                formikKey="password"
                label={ta("newPassword")}
                type="password"
              />
              <FormikTextField
                formikKey="confirmPassword"
                label={ta("confirmNewPassword")}
                type="password"
              />
              <Box m={1}>
                {error && <Toast severity="error">{error.message}</Toast>}
              </Box>
            </CardContent>
            <Divider />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
              }}
            >
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                sx={{
                  margin: "auto",
                  marginBottom: theme.spacing(2),
                  width: "100%",
                }}
                disabled={!props.isValid}
              >
                <SaveIcon /> {ta("changePassword")}
              </Button>
            </Box>
          </Card>
        </Form>
      )}
    </Formik>
  );
};

export default ChangePassword;
